(() => {
  class AffirmationReadMore {
    static init(scope = document) {
      scope.querySelectorAll(AffirmationReadMore.selector).forEach((root) => {
        if (root.dataset.affirmationInitialized === 'true') return;

        const instance = new AffirmationReadMore(root);

        if (instance.isReady) {
          AffirmationReadMore.instances.add(instance);
        }
      });
    }

    static refreshOpen() {
      AffirmationReadMore.instances.forEach((instance) => {
        if (!instance.root.isConnected) {
          AffirmationReadMore.instances.delete(instance);
          return;
        }

        instance.updateHeight();
      });
    }

    constructor(root) {
      this.root = root;
      this.button = root.querySelector('[data-affirmation-toggle]');
      this.content = root.querySelector('[data-affirmation-content]');
      this.isReady = Boolean(this.button && this.content);

      if (!this.isReady) return;

      this.root.dataset.affirmationInitialized = 'true';
      this.bindEvents();
      this.setOpen(false);
    }

    get isOpen() {
      return this.root.classList.contains('is-open');
    }

    get prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    bindEvents() {
      this.button.addEventListener('click', () => {
        this.setOpen(!this.isOpen);
      });

      this.content.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'max-height') {
          this.updateHeight();
        }
      });

      this.content.querySelectorAll('img').forEach((image) => {
        if (!image.complete) {
          image.addEventListener('load', () => this.updateHeight(), { once: true });
        }
      });
    }

    setOpen(isOpen) {
      this.root.classList.toggle('is-open', isOpen);
      this.button.setAttribute('aria-expanded', String(isOpen));
      this.content.setAttribute('aria-hidden', String(!isOpen));

      if (this.prefersReducedMotion) {
        this.content.style.maxHeight = isOpen ? 'none' : '0px';
        return;
      }

      if (isOpen) {
        this.content.style.maxHeight = '0px';
        requestAnimationFrame(() => {
          this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        });
      } else {
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        requestAnimationFrame(() => {
          this.content.style.maxHeight = '0px';
        });
      }
    }

    updateHeight() {
      if (!this.isOpen || !this.content) return;

      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }
  }

  AffirmationReadMore.selector = '[data-affirmation-read-more]';
  AffirmationReadMore.instances = new Set();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => AffirmationReadMore.init());
  } else {
    AffirmationReadMore.init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    AffirmationReadMore.init(event.target);
  });

  window.addEventListener('resize', () => {
    AffirmationReadMore.refreshOpen();
  });
})();
